<template>
  <div
    v-if="user && currentSession > 5 && needSurvey"
    id="pulseAlert"
    :class="`${$mq}Mode`"
  >
    <el-alert
      type="warning"
      :closable="false"
      show-icon
      class="mainCard"
    >
      <div
        slot="title"
        class="title"
        :class="`${$mq}Mode`"
      >
        <el-row
          :gutter="2"
          type="flex"
        >
          <el-col
            :span="responsiveCol.one"
            class="textCol defaultCursor"
          >
            <span>
              {{ $t('customAlert.pulse.pleaseSurvey') }}
            </span>
          </el-col>
          <el-col
            :span="responsiveCol.two"
            class="buttonCol"
          >
            <router-link
              class="surveyButtonWrap"
              :to="{
                name: 'pulseSurveyLeader',
                params: {role: 'leader'}
              }"
              target="_blank"
            >
              <el-button
                class="surveyButton"
                type="primary"
                round
              >
                {{ $t('customAlert.pulse.takeSurvey') }}
              </el-button>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </el-alert>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState({
      user: (state) => state.user,
      currentSession: (state) => state.processStatus.process.session,
      subTasks: (state) => state.processStatus.process.sub_tasks,
    }),

    ...mapGetters('processStatus', {
      needSurvey: 'needSurvey',
    }),

    responsiveCol() {
      const col = {};
      if (this.$mq === 'mobile') {
        col.one = 24;
        col.two = 24;
      } else if (this.$mq === 'tablet') {
        col.one = 17;
        col.two = 7;
      } else {
        col.one = 19;
        col.two = 5;
      }
      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
  #pulseAlert {
    .el-alert {
      background-color: #a0ffcc;
      color: #000;
      margin-bottom: 20px !important;
      display: flex;
      align-items: center;

      .el-alert__content {
        .title {
          display: flex;
          justify-content: space-around;
          font-size: 14px;
          font-weight: normal;
          padding: 5px 0;
          line-height: 42px;

          .el-row {
            width: 100%;
          }

          span {
            align-self: center;
          }

          .textCol {
            display: flex;
          }

          .buttonCol {
            text-align: right;

            .el-button {
              background: transparent;
              color: #000;
              border-color: #000;
              font-size: 14px;
              width: 100%;
              padding: 13px 0;
            }
          }

          &.tabletMode {
            line-height: 20px;
          }

          &.mobileMode {
            line-height: 20px;

            .el-row {
              flex-wrap: wrap;

              .el-col:first-child {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }

    &.mobileMode {
      .el-alert {
        align-items: flex-start;
      }
    }
  }
</style>

<style lang="scss">
  #pulseAlert {
    .el-alert {
      .el-alert__icon {
        font-size: 28px;
        width: 28px;
      }

      .el-alert__content {
        width: 100%;
        padding-left: 20px;
      }
    }

    &.mobileMode {
      .el-alert {
        .el-alert__icon {
          padding: 10px 0 0;
        }
      }
    }
  }
</style>
